export default {"src":"/_next/static/media/ChronicAcidReflux.c1240444.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};